import React from 'react';

interface SubtextCurrentWordProps {
  currentWord: string;
  isShaking?: boolean;
  foundAllWords?: boolean;
}

export default function SubtextCurrentWord({ currentWord, isShaking = false, foundAllWords = false }: SubtextCurrentWordProps) {
  return (
    <div className="subtext-current-word">
      <div className={`current-word-display ${isShaking ? 'shake' : ''}`}>
        {foundAllWords ? (
          <span className="completion-message">You found everything!</span>
        ) : currentWord.length > 0 ? (
          <>
            <span className="word-text">{currentWord.toUpperCase()}</span>
            <span className="cursor">|</span>
          </>
        ) : (
          <span className="cursor blinking">|</span>
        )}
      </div>
    </div>
  );
} 